import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { TransactionalSolidButton } from '@bibliocommons/base-buttons';

import { ModalHeader, ModalContent, ModalFooter } from 'app/components/shared/Modal';

export default class SpoilersForm extends React.PureComponent {
  render() {
    const { handleSubmit, isLoading } = this.props;
    return (
      <div className="cp-spoilers-form">
        <ModalHeader title={<FormattedMessage id="flag_spoilers" />} />
        <ModalContent>
          <FormattedMessage id="spoilers_note" />
        </ModalContent>
        <ModalFooter
          primaryActionButtonText={<FormattedMessage id="button_submit" />}
          primaryActionButtonTag={TransactionalSolidButton}
          handlePrimaryAction={handleSubmit}
          isLoading={isLoading}
        />
      </div>
    );
  }
}

SpoilersForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool
};
